"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var Button_1 = __importDefault(require("react-bootstrap/Button"));
var FormSubmitButton = function (props) {
    var onClick = props.onClick, title = props.title, loading = props.loading, disabled = props.disabled;
    return (react_1.default.createElement(Button_1.default, { className: 'form-submit-button', disabled: loading || disabled, onClick: onClick }, loading ? react_1.default.createElement("i", { className: "fa fa-spinner fa-spin" }) : title ? title : '送信する'));
};
FormSubmitButton.propTypes = {
    onClick: prop_types_1.default.func,
    title: prop_types_1.default.string,
    loading: prop_types_1.default.bool.isRequired,
};
exports.default = FormSubmitButton;
//# sourceMappingURL=FormSubmitButton.js.map